/* eslint-disable camelcase */
/**
 *  Participant detail [GET /api/participant/{id}]
 *  @author Livescore <@score-stats.com>
 *  @copyright 2025 livescore
 */

export enum PaymentPeriod {
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
}

export interface PaymentProduct {
    amount: number;
    currency: string;
    id: number;
    product_id: string;
    payment_tier_id: number;
    subscription_type: PaymentPeriod;
    permission: {
        id: number;
        permission: string;
        permission_description: string;
        permission_name: 'web.all_permission';
    };
}

export interface PaymentTransactions {
    status: string;
    session_data: any[];
    session_id: string;
    subscription_type: PaymentPeriod;
    product: Record<string, string | number | { permission_name: string }>;
}

export interface SerializeData {
    [prop: string]: any;
}
